'use client';

import { styled } from '@linaria/react';
import PopTopicCardTitleSkeleton from './PopTopicCardTitleSkeleton';
import PopTopicGroupTagsSkeleton from './PopTopicGroupTagsSkeleton';
import PopTopicCardContentSkeleton from './PopTopicCardContentSkeleton';

const PopTopicCardWrapper = styled.div<{ isCarousel: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 6px;
  border: 1px solid #e2e8f1;
  background-color: ${({ isCarousel }) => (isCarousel ? '#f6f8fc' : '#fff')};
  box-shadow: ${({ isCarousel }) => (isCarousel ? '0 0 6px 0 rgba(0, 47, 143, 0.1)' : 'none')};
  min-height: ${({ isCarousel }) => (isCarousel ? '640px' : 'auto')};
  position: relative;
`;

type PopTopicCardSkeletonProps = {
  isCarousel?: boolean;
};

const PopTopicCardSkeleton: React.FC<PopTopicCardSkeletonProps> = ({ isCarousel = false }) => {
  return (
    <PopTopicCardWrapper isCarousel={isCarousel}>
      <PopTopicGroupTagsSkeleton />
      <PopTopicCardTitleSkeleton isCarousel={isCarousel} />
      <PopTopicCardContentSkeleton />
    </PopTopicCardWrapper>
  );
};

export default PopTopicCardSkeleton;
